<template>
  <div id="app-index">
    <pub-head></pub-head>
    <pubs-nav></pubs-nav>
    <pub-nav></pub-nav>
    <pub-foot></pub-foot>
    <floating-button></floating-button>
  </div>
</template>
<script>
import animate from "animate.css";
import pubHead from "./head";
import pubsNav from "./nav";
import pubNav from "./public_nav";
import pubFoot from "./foot";
import floatingButton from "./floatingButton";

export default {
  components: {
    pubHead,
    pubsNav,
    pubFoot,
    pubNav,
    floatingButton
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Public/public_index.vue